import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { TextFilter, DateFilter } from "../components";
import { filterHelper} from "../helpers";
import { Link } from "react-router-dom";
import "./Site.css";
import {
  Row,
  Col,
  Button,
  ButtonGroup,
} from "reactstrap";

const SearchRecord = (props) => {
  return (
    <Row className="p-2">
      <Col>
        <TextFilter
          filterName="searchValue"
          displayName="Search"
          descriptionPrefix="contains"
          onChangeCallback={props.onChangeFilter}
          placeholder="Search by Equipment Name, Reference Code, Serial Number, or Model Number"
        />
      </Col>
      <Col xs="2">
        <DateFilter
          filterName="fromDate"
          displayName="From Date"
          onChangeCallback={props.onChangeFilter}
          value={filterHelper.get_value(
            "fromDate",
            props.filters
          )}
        />
      </Col>
      <Col xs="2">
        <DateFilter
          filterName="toDate"
          displayName="To Date"
          onChangeCallback={props.onChangeFilter}
          value={filterHelper.get_value(
            "toDate",
            props.filters
          )}
        />
      </Col>
      <Col xs="2">
        <ButtonGroup className="float-right">
          {props.hasDateFilter &&
            <Button size="sm" title={`Download ${props.title} Records`} color="dark" className="buttonGroupSpacing float-right" onClick={props.downloadReport}><FontAwesomeIcon icon="download" /></Button>
          }
          <Button size="sm" className="cbdmdSuccess float-right buttonGroupSpacing" tag={Link} to={props.url} title={`Add New ${props.title} Record`}>
            <FontAwesomeIcon icon="plus" /> Add New Record
          </Button>
        </ButtonGroup>
      </Col>
    </Row>
  );
};

export default SearchRecord;


// WEBPACK FOOTER //
// ./src/components/SearchRecord.js